import type { OrderKind } from "./types/userDashboard"

export const WAREHOUSES = ["any", "riga", "denver"]

export const availableInCountry = ({
  countryCode,
  availability,
  allowedCountries,
}: {
  countryCode: string | undefined
  availability: string[] | undefined
  allowedCountries: string[] | undefined
}): boolean => {
  if (!availability || !availability.length) return true

  if (!allowedCountries || !countryCode) return false

  return (
    allowedCountries.includes(countryCode) && availability.includes(countryCode)
  )
}

export type ShipmentDestination = {
  city: string
  stateCode: string
  countryCode: string
}

export const detectMilitaryLocation = ({
  city,
  stateCode,
  countryCode,
}: ShipmentDestination): boolean => {
  const millytaryCities = ["DPO", "APO", "FPO"]
  const millitaryStates = ["AA", "AE", "GUAM", "AP", "VI", "GU", "MP", "PR"]
  return (
    countryCode === "US" &&
    (millytaryCities.includes(city.toUpperCase()) ||
      millitaryStates.includes(stateCode.toUpperCase()))
  )
}

export const checkIsPrioritySampleOrder = (userProductOrder: {
  kind: OrderKind
  lines: {
    userProduct: {
      productSettings: {
        sku: string
      }
    }
    count: number
  }[]
}): boolean => {
  if (userProductOrder.kind !== "SAMPLE") return false

  const skuCounts = userProductOrder.lines.reduce(
    (acc, line) => {
      acc[line.userProduct.productSettings.sku] =
        (acc[line.userProduct.productSettings.sku] || 0) + line.count
      return acc
    },
    {} as Record<string, number>,
  )

  const hasHighSkuCount = Object.values(skuCounts).some((count) => count > 3)

  return !hasHighSkuCount
}
